import React from "react";
import styled from "styled-components";

import Nav from "../components/redesign/Nav";
import HeroChat from "../components/redesign/HeroChat";
import HowItWorks from "../components/redesign/HowItWorks";
import Pillars from "../components/redesign/Pillars";
import Reviews from "../components/redesign/Reviews";
import Industries from "../components/redesign/Industries";
// import Calculator from "../components/redesign/Calculator"; // oculto temporalmente
import Dashboard from "../components/redesign/Dashboard";
import MetaPartner from "../components/redesign/MetaPartner";
import Faqs from "../components/redesign/Faqs";
import FooterChat from "../components/redesign/FooterChat";

const Page = styled.div`
  background: var(--bg);
  min-height: 100vh;
  text-align: left;
`;

export default function PecHome() {
  return (
    <Page>
      <Nav />
      <main>
        <HeroChat />
        <HowItWorks />
        <Pillars />
        <Reviews />
        <Industries />
        <Dashboard />
        {/* <Calculator /> */}
        <MetaPartner />
        <Faqs />
      </main>
      <FooterChat />
    </Page>
  );
}
